<template>
  <v-container grid-list-md>
    <v-dialog v-model="edit.showModal" max-width="550px">
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <h2>Extra artikelen</h2>
            </v-flex>
            <v-flex xs4>
              <v-btn color="green darken-1" flat @click.native="addItem()" v-if="editable">Nieuw</v-btn>
            </v-flex>
            <v-flex xs8>
              <v-select
                :items="availableAdditionalItems"
                v-model="selectAvailable"
                label="Kies bestaande"
                item-text="description"
                item-value="id"
                return-object
                single-line
                menu-props="{'bottom':true}"
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-data-table
                v-bind:headers="headers"
                v-bind:items="reservation.costData.additionalItems"
                hide-actions
                :rows-per-page-items="[25,50]"
                no-data-text="Geen gegevens"
                item-key="id"
              >
                <template slot-scope="props">
                  <tr>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                      @click="changeSort(header.value)"
                    >
                      <v-icon>arrow_upward</v-icon>
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <tr>
                    <td class="text-xs-left">
                      <v-edit-dialog lazy>
                        {{ props.item.quantity }}
                        <v-text-field
                          type="number"
                          min="0"
                          step="1"
                          slot="input"
                          label="Edit"
                          v-model="props.item.quantity"
                          :readonly="!editable"
                          single-line
                        ></v-text-field>
                      </v-edit-dialog>
                    </td>
                    <td class="text-xs-left">
                      <v-edit-dialog lazy>
                        {{ props.item.price }}
                        <v-text-field
                          type="number"
                          min="0"
                          step="0.01"
                          slot="input"
                          label="Edit"
                          v-model="props.item.price"
                          :readonly="!editable"
                          single-line
                        ></v-text-field>
                      </v-edit-dialog>
                    </td>
                    <td class="text-xs-left">
                      <v-edit-dialog lazy>
                        {{ props.item.vat }}
                        <v-checkbox
                          slot="input"
                          label="BTW vrij"
                          v-model="props.item.vatFree"
                          value="0"
                          @change="setVAT(props.item)"
                          :readonly="!editable"
                        ></v-checkbox>
                      </v-edit-dialog>
                    </td>
                    <td class="text-xs-left">
                      <v-edit-dialog lazy>
                        {{ props.item.description }}
                        <v-text-field
                          type="text"
                          slot="input"
                          label="Edit"
                          v-model="props.item.description"
                          single-line
                        ></v-text-field>
                      </v-edit-dialog>
                    </td>
                    <td class="text-xs-left">
                      <v-btn
                        v-if="editable"
                        flat
                        icon
                        color="pink"
                        @click="deleteAdditionalItem(props.item)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-layout wrap>
          <v-flex xs9 md8>
            <v-btn
              color="gray darken-1"
              flat="flat"
              @click.native="reservation.costData.additionalItems = initAdditionalItems; edit.showModal = false;"
            >Sluiten</v-btn>
          </v-flex>
          <v-flex xs3 md4 text-xs-right>
            <v-btn color="primary" @click.native="edit.showModal = false;">Opslaan</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import * as utils from "@/utils/utils";
import { _ } from "vue-underscore";

export default {
  name: "AdditionalItems",
  props: ["reservation", "editable", "edit"],
  utils: utils,
  created: function() {
    if (typeof this.reservation.costData.additionalItems === "undefined") {
      this.reservation.costData.additionalItems = [];
    }

    this.initAdditionalItems = this.reservation.costData.additionalItems.slice();
  },
  data() {
    return {
      items: [],
      selectAvailable: null,
      initAdditionalItems: [],
      availableAdditionalItems: [],
      headers: [
        { text: "Aantal", value: "quantity", class: "" },
        { text: "Bedrag", value: "price", class: "" },
        { text: "BTW", value: "vat", class: "" },
        { text: "Omschrijving", value: "description", class: "" },
        { text: "/", value: "", class: "", sortable: false }
      ]
    };
  },
  watch: {
    "edit.showModal": function(value) {
      if (value) {
        if (typeof this.reservation.costData.additionalItems === "undefined") {
          this.reservation.costData.additionalItems = [];
        }

        this.initAdditionalItems = this.reservation.costData.additionalItems.slice();
        this.getItems();
      }
    },
    selectAvailable: function(value) {
      // Add item
      this.reservation.costData.additionalItems.push({
        quantity: 1,
        description: value.description,
        price: value.price,
        vat: value.vat,
        id: value.value,
        itemId: value.id,
        new: false
      });
    }
  },
  methods: {
    getItems() {
      var self = this;
      utils
        .getData(basePath + "api/reservations/getAdditionalItems/")
        .then(function(json) {
          if (json && json.data) {
            self.availableAdditionalItems = json.data;
          }
        });
    },
    deleteAdditionalItem(item) {
      var self = this;

      // Check if already in DB
      if (this.reservation.id && !item.new) {
        item.reservationId = this.reservation.id;
        utils
          .setData(basePath + "api/reservations/deleteAdditionalItem/", item)
          .then(function(json) {
            if (json && json.data === 1) {
              self.reservation.costData.additionalItems = _.without(
                self.reservation.costData.additionalItems,
                _.findWhere(self.reservation.costData.additionalItems, {
                  itemId: item.itemId
                })
              );
            }
          });
      } else {
        self.reservation.costData.additionalItems = _.without(
          self.reservation.costData.additionalItems,
          _.findWhere(self.reservation.costData.additionalItems, {
            id: item.id
          })
        );
      }
    },
    addItem() {
      this.reservation.costData.additionalItems.push({
        quantity: 1,
        description: "Nieuw artikel",
        price: 0,
        new: true,
        vat: 21,
        id: this.reservation.costData.additionalItems.length
      });
    },
    setVAT(item) {
      if (parseInt(item.vatFree) !== 0) {
        item.vat = 21;
      } else {
        item.vat = 0;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Reservations/AdditionalItems.vue